/** VUEX module for category management **/
import responseNotification from '../lib/responseNotification.js'

import {
  addFormatToCategory,
  createCategory,
  deleteCategory, deleteFormatFromCategory,
  getCategories,
  getCategoryFormats,
  updateCategory
} from '../lib/api/calls'

export default {
  namespaced: true,
  state: {
    categories: []
  },
  mutations: {
    setCategories (state, categories) {
      state.categories = categories
    }
  },
  actions: {
    load ({commit}) {
      getCategories().then(categories => commit('setCategories', categories))
    },
    create (context, {data, callback}) {
      createCategory(data).then((response) => {
        responseNotification(context, response, 'Category created!')
        context.dispatch('load')
        if (callback) callback(response)
      }).catch((e) => {
        console.log('e was', e)
        responseNotification(context, {error: 'Could not create category!'})
      })
    },
    update (context, {id, category, callback}) {
      updateCategory(id, category).then((response) => {
        responseNotification(context, response, 'Category updated!')
        context.dispatch('load')
        if (callback) callback(response)
      })
    },
    delete (context, id) {
      deleteCategory(id).then((response) => {
        responseNotification(context, response, 'Category deleted!')
        context.dispatch('load')
      })
    }
  },
  modules: {
    formats: {
      namespaced: true,
      state: {
        categoryFormats: []
      },
      mutations: {
        setCategoryFormats (state, categoryFormats) {
          state.categoryFormats = categoryFormats
        }
      },
      actions: {
        load ({commit}) {
          getCategoryFormats().then(categoryFormats => commit('setCategoryFormats', categoryFormats))
        },
        add (context, payload) {
          addFormatToCategory(payload).then((response) => {
            responseNotification(context, response, 'Format Added!')
            context.dispatch('categories/load', {}, {root: true})
            context.dispatch('load')
          })
        },
        delete (context, id) {
          deleteFormatFromCategory(id).then((response) => {
            responseNotification(context, response, 'Format Removed!')
            context.dispatch('categories/load', {}, {root: true})
            context.dispatch('load')
          })
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/categories.js